// extracted by mini-css-extract-plugin
export default {"sm":"LegendValueBase_sm__0URUk","md":"LegendValueBase_md__UjBme","lg":"LegendValueBase_lg__UibAa"};